<template>
    <div>
        <ob-spinner v-if="H1BLoader" loading-text="Loading..."></ob-spinner>
       
        <ob-folder :expand="H1BDetails.isExpand">
            <template slot="header">
                <template>
                    <div>
                        <div class="col-sm-8" style="padding-left:0px;">
                            <h4 class="folder-header-heading" v-if="H1BDetails.h1BType != ''">{{H1BDetails.h1BType}}</h4>
                            <h4 class="folder-header-heading" v-else>N/A</h4>
                            <p class="folder-header-sub-heading" v-if="H1BDetails.h1BStatus == 'H-1B Approved'">
                                <span v-if="H1BDetails.isPremiumPetition== true"><img :src="`${CDNIMAGESBASEURL}/hrspa/Content/Images/premium_badge_green_icon.svg`"> Premium Process | Premium Initiated Date : {{premiumpetitionDate}} | </span> 
                            <span>  Petition Filed Date : <span> {{petitionDate}} </span> 
                            <span v-if="H1BDetails.h1BStatus == 'H-1B In-Progress' && H1BDetails.ReceiptNumber != 'N/A'"> |I-797C Receipt Number: {{H1BDetails.ReceiptNumber ? H1BDetails.ReceiptNumber : "N/A" }} </span>
                             <span v-else-if="H1BDetails.ApprovedDocType">| {{H1BDetails.ApprovedDocType}} </span>
                              <span v-if="getH1bStartDate != 'N/A'"> | {{getDate1DisplayName}}: {{getH1bStartDate}}  </span>
                               <span v-if="getH1bEndDate  != 'N/A' && H1BDetails.h1BStatus != 'H-1B Revoked' && H1BDetails.h1BStatus != 'H-1B CAP Case Rejected'"> | {{getDate2DisplayName}}: {{getH1bEndDate}} </span> </span>
                            </p>
                            <p class="folder-header-sub-heading" v-else-if="H1BDetails.h1BStatus == 'H-1B In-Progress'">
                                <span v-if="H1BDetails.isPremiumPetition== true"><img :src="`${CDNIMAGESBASEURL}/hrspa/Content/Images/premium_badge_green_icon.svg`"> Premium Process | Premium Initiated Date : {{premiumpetitionDate}} | </span> <span v-if="H1BDetails.isPremiumPetition== false"> Initiated Date: {{H1BDetails.petitionIniatedDate | formatDate('MM/DD/YYYY')}} | </span><span> Petition Filed By : {{H1BDetails.petitionFiledByName}} | Petition Filed Date : <span > {{petitionDate}} </span></span>
                            </p>
                            <p class="folder-header-sub-heading" v-else>  <!-- v-if="H1BDetails.h1BStatus == 'H-1B Initiated' || H1BDetails.h1BStatus == 'H-1B Approved'"> -->
                                 Initiated Date :
                                <span v-if="this.H1BDetails.petitionIniatedDate != null && this.H1BDetails.petitionIniatedDate != '0001-01-01T00:00:00'">{{this.H1BDetails.petitionIniatedDate | formatDate('MM/DD/YYYY')}} </span>
                                <span v-else> N/A </span> 
                                <!-- <span class="h1b-days" v-if="H1BDetails.h1bEndDate  != null && H1BDetails.h1bEndDate  != ''">{{H1BDetails.h1bEndDate}}</span>
                                <span v-else> N/A </span> -->
                            </p>
                        </div>
                        <div class="col-sm-2 h1b-status">
                            <span class="h1b-status--label">Status</span>
                            <span class="h1b-status--message" v-if="H1BDetails.h1BStatus != ''">{{H1BDetails.h1BStatus}}</span>
                            <span class="h1b-status--message" v-else>N/A</span>
                        </div>
                    </div>
                </template>
            </template>


            <template slot="body">
                <div class="row oneDoc infoSec">
                    <p class="header-text">H1B PACKET</p>
                    <div class="col-md-12 pL0 infofields">
                        <div class="col-md-3 pL0">
                            <div class="col-md-12 pL0">
                                Petition Processing Type
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle">
                                {{this.H1BDetails.petitionType}}
                            </div>

                        </div>
                        <div class="col-md-3 pL0" v-if="this.H1BDetails.isPremiumPetition == true">
                            <div class="col-md-12 pL0">
                                Premium Initiated Date
                                
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle" v-if="this.H1BDetails.PremiumPetitionIniatedDate != null && this.H1BDetails.PremiumPetitionIniatedDate != '0001-01-01T00:00:00'">
                                {{this.H1BDetails.PremiumPetitionIniatedDate | formatDate('MM/DD/YYYY')}}
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle" v-else>
                                N/A
                            </div>
                        </div>
                        <div class="col-md-3 pL0" v-else>
                            <div class="col-md-12 pL0">
                                Initiated Date
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle" v-if="this.H1BDetails.petitionIniatedDate != null && this.H1BDetails.petitionIniatedDate != '0001-01-01T00:00:00'">
                                {{this.H1BDetails.petitionIniatedDate | formatDate('MM/DD/YYYY')}}
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle" v-else>
                                N/A
                            </div>
                        </div>
                        <div class="col-md-3 pL0">
                            <div class="col-md-12 pL0">
                                Petition Filed By
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle" v-if="this.H1BDetails.petitionFiledByName != null">
                                {{this.H1BDetails.petitionFiledByName}}
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle" v-else>
                                {{N/A}}
                            </div>
                        </div>
                        <div class="col-md-3 pL0">
                            <div class="col-md-12 pL0">
                                Email Address
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle" v-if="this.H1BDetails.petitionFiledByEmail != null">
                                {{this.H1BDetails.petitionFiledByEmail}}
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle" v-else>
                                {{N/A}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 pL0">
                        <div class="col-md-12 pL0">
                            Comments
                        </div>
                        <div class="col-md-12 pL0 fontWeighStyle">
                            {{this.H1BDetails.comments ? this.H1BDetails.comments : 'N/A'}}
                        </div>
                    </div>
                </div>



                <!-- Linked LCA Details -->
                <div class="row oneDoc" v-if="this.H1BDetails.documentLCA">
                    <div class="col-md-8">
                        <span class="document-list__headingApprovedStyle">Certified/Signed LCA &nbsp;
                        <span class="document-list__statusApprovedStyle">&#10003;</span>
                        </span>
                    </div>
                    <!-- <div class="col-md-8 pL0" v-else>
                        <span class="document-list__NoDocument">Certified/Signed LCA &nbsp;
                        <span class="document-list__NostatusStyle">?</span>
                        </span>
                    </div> -->
                    <div class="col-md-4" align="right" style="padding: 0 0 0 0;">
                        <ob-dropdown title="Actions" style="z-index:20000">
                            <ob-dropdown-list-item @click.native="viewDocument('LCA')">Preview</ob-dropdown-list-item>
                            <ob-dropdown-list-item @click.native="downloadDocument('LCA')">Download</ob-dropdown-list-item>
                        </ob-dropdown>
                    </div>
                </div>
                <!-- Linked LCA Details -->
                

                <!-- Form I-129 Details -->
                <div class="row oneDoc" v-if="this.H1BDetails.documentI129">
                    <div class="col-md-8">
                        <span class="document-list__headingApprovedStyle">Form I-129 &nbsp;
                        <span class="document-list__statusApprovedStyle">&#10003;</span>
                        </span>
                    </div>
                    <!-- <div class="col-md-8 pL0" v-else>
                        <span class="document-list__NoDocument">Signed Form I-129 &nbsp;
                        <span class="document-list__NostatusStyle">?</span>
                        </span>
                    </div> -->
                    <div class="col-md-4" align="right" style="padding: 0 0 0 0;">
                        <ob-dropdown title="Actions" style="z-index:20000">
                            <ob-dropdown-list-item @click.native="viewDocument('FormI129')">Preview</ob-dropdown-list-item>
                            <ob-dropdown-list-item @click.native="downloadDocument('FormI129')">Download</ob-dropdown-list-item>
                        </ob-dropdown>
                    </div>
                </div>
                <!-- Form I-129 Details -->


                <!-- Form I-129 Details -->
                <div class="row oneDoc" v-if="this.H1BDetails.documentI129Signed">
                    <div class="col-md-8">
                        <span class="document-list__headingApprovedStyle">Signed Form I-129 &nbsp;
                        <span class="document-list__statusApprovedStyle">&#10003;</span>
                        </span>
                    </div>
                    <div class="col-md-4" align="right" style="padding: 0 0 0 0;">
                        <ob-dropdown title="Actions" style="z-index:20000">
                            <ob-dropdown-list-item @click.native="viewDocument('SignedFormI129')">Preview</ob-dropdown-list-item>
                            <ob-dropdown-list-item @click.native="downloadDocument('SignedFormI129')">Download</ob-dropdown-list-item>
                        </ob-dropdown>
                    </div>
                </div>
                <!-- Form I-129 Details -->

                
                <!-- Form I-539 Details -->
                <div class="row oneDoc" v-if="this.H1BDetails.documentI539">
                    <div class="col-md-8 pL0" >
                        <span class="document-list__headingApprovedStyle">Signed Form I-539 &nbsp;
                            <span class="document-list__statusApprovedStyle">&#10003;</span>
                        </span>
                    </div>
                    <div class="col-md-4 PR2" align="right">
                        <ob-dropdown title="Actions" style="z-index:20000">
                            <ob-dropdown-list-item @click.native="viewDocument('FormI539')">Preview</ob-dropdown-list-item>
                            <ob-dropdown-list-item @click.native="downloadDocument('FormI539')">Download</ob-dropdown-list-item>
                        </ob-dropdown>
                    </div>
                    <div class="col-md-12 PL2">
                        <span class="document-list__title file_name_span">Signed Date</span>
                        <div>
                            <span  style="color:#143361;font-weight:600;font-size:13px" v-if="getSignedDate() !=''">{{getSignedDate()}}</span>
                            <span v-else  style="color:#143361;font-weight:600;font-size:13px">N/A</span>
                        </div>
                    </div>
                </div>
                <!-- Form I-539 Details -->


                <!-- Form I-539-A Details -->
                <!-- <div class="row PL1" v-if="this.H1BDetails.documentI539A && this.H1BDetails.documentI539A.MetadataValues && this.H1BDetails.documentI539A.MetadataValues.length > 0">
                    <div v-for="doc in this.H1BDetails.documentI539A.MetadataValues" :key="doc.DocumentId">
                        <div class="col-md-12 pL0 " >
                            <div class="col-md-8 pL0" v-if=" doc.DocType == 'SignedFormI539A'">
                                <span class="document-list__headingApprovedStyle">{{getFormI539AName(doc)}} &nbsp;
                                    <span class="document-list__statusApprovedStyle">&#10003;</span>
                                </span>
                            </div>
                            <div class="col-md-4 pL0" align="right" style="padding: 0 0 0 0;" v-if=" doc.DocType == 'SignedFormI539A'">
                                <ob-dropdown title="Actions" style="z-index:20000">
                                    <ob-dropdown-list-item @click.native="viewDocumentI539A(doc)">Preview</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="downloadDocumentI539A(doc)">Download</ob-dropdown-list-item>
                                </ob-dropdown>
                            </div>
                            </div>
                        <div class="col-md-12 PL2 PD1">
                            <span class="document-list__title file_name_span" >Signed Date</span>
                            <div>
                                <span  style="color:#143361;font-weight:600;font-size:13px" v-if="getSignedDateI539A(doc) !=''">{{getSignedDateI539A(doc)}}</span>
                                <span v-else  style="color:#143361;font-weight:600;font-size:13px">N/A</span>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- Form I-539-A Details -->


                <!-- Complete H1B Packet -->
                <div class="row oneDoc" v-if="this.H1BDetails.documentComplete">
                    <div class="col-md-8">
                        <span class="document-list__headingApprovedStyle">{{H1BDetails.documentComplete.DisplayName}}&nbsp;
                        <span class="document-list__statusApprovedStyle">&#10003;</span>
                        </span>
                    </div>
                    <!-- <div class="col-md-8" v-else>
                        <span class="document-list__NoDocument">Complete H-1B packet &nbsp;
                        <span class="document-list__NostatusStyle">?</span>
                        </span>
                    </div> -->
                    <div class="col-md-4" align="right" style="padding: 0 0 0 0;">
                        <ob-dropdown title="Actions" style="z-index:20000">
                            <ob-dropdown-list-item @click.native="viewDocument('CompleteH1B')">Preview</ob-dropdown-list-item>
                            <ob-dropdown-list-item @click.native="downloadDocument('CompleteH1B')">Download</ob-dropdown-list-item>
                        </ob-dropdown>
                    </div>
                </div>
                <!-- Complete H1B Packet -->


                <!-- Other Document -->
                <div class="row PL1" v-if="H1BDetails.OtherDocuments && H1BDetails.OtherDocuments.length > 0">
                    <ob-ess-document v-for="(docData, index) in H1BDetails.OtherDocuments" :key="index" :documentList="docData" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- Other Document -->


                <!-- Requested Document Details -->
                <div class="row PL3" v-if="this.H1BDetails.isH1BPetitionDocumentsRequested == true">                                                     
                    <div class="col-md-12 pL0 PD1">
                        <div class="col-md-8 pL0">
                            <span class="document-list__headingStyle" v-bind:class="{'ApprovedDocument-list__headingStyle': this.H1BDetails.essDocumentStatus == 'Approved'  && !this.H1BDetails.IsShowReviewButton && this.H1BDetails.IsHRManager} ">Beneficiary Information &nbsp;
                                <span class="document-list__statusStyle" v-bind:class="{'ApprovedDocument-list__statusStyle': this.H1BDetails.essDocumentStatus == 'Approved'  && !this.H1BDetails.IsShowReviewButton && this.H1BDetails.IsHRManager} ">&#10003;</span>
                            </span>
                            <span class="cancelH1BPetitonDocStatus margDispStyle" v-if="this.H1BDetails.essDocumentStatus == 'Cancelled'">Canceled Request</span>
                            <span class="H1BPetitonDocStatus margDispStyle" v-if="this.H1BDetails.essDocumentStatus == 'Approved' && this.H1BDetails.IsShowReviewButton && this.H1BDetails.IsHRManager">Submitted</span>
                            <span class="H1BPetitonDocStatusApproved margDispStyle" v-if="this.H1BDetails.essDocumentStatus == 'Approved' && !this.H1BDetails.IsShowReviewButton && this.H1BDetails.IsHRManager">Approved</span>
                            <span class="H1BPetitonDocStatus margDispStyle" v-if="this.H1BDetails.essDocumentStatus == 'InComplete'">Incomplete</span>
                            <span class="H1BPetitonDocStatusRejected margDispStyle" v-if="this.H1BDetails.essDocumentStatus == 'Rejected'">Rejected</span>
                            <span class="H1BPetitonDocStatus margDispStyle" v-if="this.H1BDetails.essDocumentStatus == 'Submitted' || this.H1BDetails.essDocumentStatus == 'Resubmitted'">Pending Review</span>

                        </div>

                        <div class="col-md-4 pL0" align="right" style="padding: 0 0 0 0;">
                            <ob-button type="primary" width="80px" v-if="this.H1BDetails.essDocumentStatus == 'Pending' || this.H1BDetails.essDocumentStatus == 'ReSending'" @click="openempchecklistForm">Start</ob-button>
                            <span v-if="this.H1BDetails.essDocumentStatus == 'InComplete'"><ob-button type="primary"  @click="openempchecklistForm">Complete</ob-button>&nbsp;</span>
                            <span v-if="this.H1BDetails.essDocumentStatus == 'Rejected'"><ob-button type="primary" @click="openempchecklistForm">Re-Submit</ob-button>&nbsp;</span>
                            <ob-dropdown title="Actions" v-if="this.H1BDetails.essDocumentStatus == 'Rejected'|| this.H1BDetails.essDocumentStatus == 'Approved' || this.H1BDetails.essDocumentStatus == 'Submitted' || this.H1BDetails.essDocumentStatus == 'Resubmitted'">
                                <ob-dropdown-list-item @click.native="previewHTML">Preview</ob-dropdown-list-item>
                                <ob-dropdown-list-item @click.native="downloadHTML">Download</ob-dropdown-list-item>
                            </ob-dropdown>
                        </div>

                        <div class="col-md-12 pL0 padTopStyle" v-if="this.H1BDetails.essDocumentStatus == 'Pending' || this.H1BDetails.essDocumentStatus == 'ReSending'">
                            <span><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_icon.svg`" width="15" slot="reference" /></span>
                            <span><p class="inform-text">Your employer has requested H-1B petition documents. Please click on <span class="fontWeightSty">start</span> to provide all the requested information/documents.</p>
                            </span>
                        </div>

                        <div class="col-md-12 pL0 padTopLowStyle" v-if="this.H1BDetails.essDocumentStatus == 'Submitted' || this.H1BDetails.essDocumentStatus == 'Resubmitted'">
                            <span><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_icon.svg`" width="15" slot="reference" /></span>
                            <span><p class="inform-text">Your information is under verification. You will be notified once it is done.</p></span>
                        </div>

                        <div class="col-md-12 pL0 padTopStyle" v-if="this.H1BDetails.essDocumentStatus == 'InComplete'">
                            <span><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_icon.svg`" width="15" slot="reference" /></span>
                            <span><p class="inform-text">Your information is saved but not yet submitted. Please <span class="fontWeightSty">complete</span> and submit the information at the earliest.</p>
                            </span>
                        </div>

                        <div class="col-md-12 pL0 padTopLowStyle" v-if="this.H1BDetails.submittedDate != null && this.H1BDetails.submittedDate != '0001-01-01T00:00:00'">
                            <span class="col-md-3 pL0">  
                            <p class="m0">Employee Submitted Date</p>
                            <p v-if="this.H1BDetails.submittedDate != null && this.H1BDetails.submittedDate != '0001-01-01T00:00:00'" class="date">{{this.H1BDetails.submittedDate | formatDate('MM/DD/YYYY')}}</p>
                            </span>
                        </div>

                        <div class="row" style="margin:0px;" v-if="this.H1BDetails.ReviewerInformation != null">
                            <div class="col-md-12 pL0 padTopBotStyle"  v-for="(h1bReviewerinfo , hIndex) in this.H1BDetails.ReviewerInformation" :key="hIndex"> 
                                <div class="col-md-12 pL0 padBotHighStyle" >
                                    <div class="col-md-2 pL0">
                                        <div class="col-md-12 pL0">
                                            Reviewer Name
                                        </div>
                                        <div class="col-md-12 pL0 date Excess_Content" :title="h1bReviewerinfo.ReviewerName">
                                            {{h1bReviewerinfo.ReviewerName}}
                                        </div>

                                    </div>
                                    <div class="col-md-2 pL0">
                                        <div class="col-md-12 pL0">
                                            Designation 

                                        </div>
                                        <div class="col-md-12 pL0 date">
                                            {{h1bReviewerinfo.Designation}}
                                        </div>
                                    </div>
                                    <div class="col-md-2 pL0">
                                        <div class="col-md-12 pL0">
                                            Email Address

                                        </div>
                                        <div class="col-md-12 pL0 date excess-header" :title="h1bReviewerinfo.Email">
                                            {{h1bReviewerinfo.Email}}
                                        </div>
                                    </div>
                                    <div class="col-md-4 pL0" v-if="h1bReviewerinfo.SharedDate != '0001-01-01T00:00:00'" >
                                        <div class="col-md-12 pL0" v-if="h1bReviewerinfo.Status == 'Pending'">
                                            Previous Reviewed Date & Time
                                        </div>
                                        <div class="col-md-12 pL0" v-else>
                                            Reviewed Date & Time
                                        </div>
                                        <div class="col-md-12 pL0 date">
                                            {{h1bReviewerinfo.SharedDate | formatDate('MM/DD/YYYY hh:mm:ss A')}}
                                        </div>
                                    </div>
                                    <div class="col-md-3 pL0" v-if="h1bReviewerinfo.CancelledDate != '0001-01-01T00:00:00'" >
                                        <div class="col-md-12 pL0">
                                            Canceled Date & Time
                                        </div>
                                        <div class="col-md-12 pL0 date">
                                            {{h1bReviewerinfo.CancelledDate | formatDate('MM/DD/YYYY hh:mm:ss A')}}
                                        </div>
                                    </div>
                                    <div class="col-md-2 pL0" >
                                        <div class="col-md-12 pL0">
                                            Status
                                        </div>
                                        <div v-if="h1bReviewerinfo.Status != 'Cancelled'" class="col-md-12 pL0" :class="{'Headline_StatusApprovedMessage': h1bReviewerinfo.Status == 'Approved' , 'Headline_StatusRejectedMessage' : h1bReviewerinfo.Status == 'Rejected', 'Headline_StatusIncompleteMessage' : h1bReviewerinfo.Status == 'Pending'} " >
                                            {{h1bReviewerinfo.Status}}
                                        </div>
                                        <div v-else class="col-md-12 pL0 Headline_StatusRejectedMessage">
                                            Canceled
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 pL0 padBotHighStyle" v-if="h1bReviewerinfo.ReviewerTabComments.length > 0">
                                    <div class="col-md-12 pL0 padBotStyle" v-if="h1bReviewerinfo.Status == 'Approved'">
                                        Comments
                                    </div>
                                    <div class="col-md-12 pL0 padBotStyle" v-if="h1bReviewerinfo.Status == 'Rejected'">
                                        Reason(s) for Rejection
                                    </div>
                                    <div  class="col-md-12 commentStyle" v-for="(d,dIndex) in h1bReviewerinfo.ReviewerTabComments" :key="dIndex">
                                    <span style="max-width: 450px;word-break: break-all;" v-if="d.TabType == 'H1BPetitionDocumentsReview'">H-1B Petition documents Review : {{d.Comments}}</span> 
                                    <span style="max-width: 450px;word-break: break-all;" v-else> {{d.TabType}} : {{d.Comments}}</span>
                                    </div>
                                </div>
                                <div class="col-md-12 pL0 padBotHighStyle" v-if="h1bReviewerinfo.CancelledReason != ''">
                                    <div class="col-md-12 pL0 padBotStyle">
                                        Reasons
                                    </div>
                                    <div  class="col-md-12 commentStyle" >
                                    {{h1bReviewerinfo.CancelledReason}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Requested Document Details -->

                
                <!-- H1B APPROVAL COPY -->
                <div class="row PL1" v-if="H1BDetails.documentI797">
                    <div class="col-md-12 borderSolid" style="padding: 10px 15px;">
                        <div class="col-md-8" style="padding-left:0px;">
                            <p style="" class="header-text"> {{ H1BDetails.documentI797.DisplayText }}</p>
                        </div>
                    </div>
                    <ob-ess-document :documentList="H1BDetails.documentI797" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- H1B APPROVAL COPY -->
                

                <!-- H1B I-797 Receipt Notice -->
                <div class="row PL1" v-if="H1BDetails.documentI797C">
                    <div class="col-md-12 borderSolid" style="padding: 10px 15px;">
                        <div class="col-md-8" style="padding-left:0px;">
                            <p style="" class="header-text"> {{ H1BDetails.documentI797C.DisplayText }}</p>
                        </div>
                    </div>
                    <ob-ess-document :documentList="H1BDetails.documentI797C" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- H1B I-797 Receipt Notice -->


                <!-- H1B Courier Tracking Information -->
                <div class="row PL1" v-if="H1BDetails.CourierDocuments && H1BDetails.CourierDocuments.length > 0">
                    <div class="col-md-12 borderSolid" style="padding: 10px 15px;">
                        <div class="col-md-8" style="padding-left:0px;">
                            <p style="" class="header-text"> {{ H1BDetails.CourierDocuments[0].DisplayText }}</p>
                        </div>
                    </div>

                    <div class="col-md-12 pL0 courierinfofields">
                        <div class="col-md-3 pL0" v-if="H1BDetails.CourierFields.some(x => x.Key == 'SelectCourier')">
                            <div class="col-md-12 pL0">
                                Courier Service
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle">
                                {{H1BDetails.CourierFields.some(x => x.Key == 'SelectCourier' && x.Value) ? H1BDetails.CourierFields.find(x => x.Key == 'SelectCourier').Value : 'N/A'}}
                            </div>
                        </div>
                        <div class="col-md-3 pL0" v-if="H1BDetails.CourierFields.some(x => x.Key == 'OtherCourier' && x.Value)">
                            <div class="col-md-12 pL0">
                                Other Courier Service
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle">
                                {{ H1BDetails.CourierFields.find(x => x.Key == 'OtherCourier').Value }}
                            </div>
                        </div>
                        <div class="col-md-3 pL0" v-if="H1BDetails.CourierFields.some(x => x.Key == 'TrackingLink')">
                            <div class="col-md-12 pL0">
                                Tracking Link
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle">
                                {{H1BDetails.CourierFields.some(x => x.Key == 'TrackingLink' && x.Value) ? H1BDetails.CourierFields.find(x => x.Key == 'TrackingLink').Value : 'N/A'}}
                            </div>
                        </div>
                        <div class="col-md-3 pL0" v-if="H1BDetails.CourierFields.some(x => x.Key == 'IssueDate')">
                            <div class="col-md-12 pL0">
                                Courier/Petition Filed Date
                            </div>
                            <div class="col-md-12 pL0 fontWeighStyle">
                                {{H1BDetails.CourierFields.some(x => x.Key == 'IssueDate' && x.Value) ? H1BDetails.CourierFields.find(x => x.Key == 'IssueDate').Value : 'N/A'}}
                            </div>
                        </div>
                    </div>

                    <ob-ess-document v-for="(docData, index) in H1BDetails.CourierDocuments" :key="index" :documentList="docData" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- H1B Courier Tracking Information -->
  

                <!-- H1B Petitioner Documents -->
                <div class="row PL1" v-if="H1BDetails.PetitionerDocuments && H1BDetails.PetitionerDocuments.length > 0">
                    <div class="col-md-12 borderSolid" style="padding: 10px 15px;">
                        <div class="col-md-8" style="padding-left:0px;">
                            <p style="" class="header-text"> {{ H1BDetails.PetitionerDocuments[0].DisplayText }}</p>
                        </div>
                    </div>
                    <ob-ess-document v-for="(docData, index) in H1BDetails.PetitionerDocuments" :key="index" :documentList="docData" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- H1B Petitioner Documents -->


                <!-- H1B Current Work Authorization Documents -->
                <div class="row PL1" v-if="H1BDetails.CurrentWorkAuthDocuments && H1BDetails.CurrentWorkAuthDocuments.length > 0">
                    <div class="col-md-12 borderDashed" style="padding: 10px 15px;">
                        <div class="col-md-8" style="padding-left:0px;">
                            <p style="" class="header-text"> {{ H1BDetails.CurrentWorkAuthDocuments[0].DisplayText }}</p>
                        </div>
                    </div>
                    <ob-ess-document v-for="(docData, index) in H1BDetails.CurrentWorkAuthDocuments" :key="index" :documentList="docData" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- H1B Current Work Authorization Documents -->


                <!-- H1B Beneficiary Documents -->
                <div class="row PL1" v-if="H1BDetails.BeneficiaryDocuments && H1BDetails.BeneficiaryDocuments.length > 0">
                    <div class="col-md-12 borderDashed" style="padding: 10px 15px;">
                        <div class="col-md-8" style="padding-left:0px;">
                            <p style="" class="header-text"> {{ H1BDetails.BeneficiaryDocuments[0].DisplayText }}</p>
                        </div>
                    </div>
                    <ob-ess-document v-for="(docData, index) in H1BDetails.BeneficiaryDocuments" :key="index" :documentList="docData" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- H1B Beneficiary Documents -->


                <!-- H1B RightToControl Documents -->
                <div class="row PL1" v-if="H1BDetails.RTCDocuments && H1BDetails.RTCDocuments.length > 0">
                    <div class="col-md-12 borderDashed" style="padding: 10px 15px;">
                        <div class="col-md-8" style="padding-left:0px;">
                            <p style="" class="header-text"> {{ H1BDetails.RTCDocuments[0].DisplayText }}</p>
                        </div>
                    </div>
                    <ob-ess-document v-for="(docData, index) in H1BDetails.RTCDocuments" :key="index" :documentList="docData" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- H1B RightToControl Documents -->


                <!-- H1B Client Documents -->
                <div class="row PL1" v-if="H1BDetails.ClientDocuments && H1BDetails.ClientDocuments.length > 0">
                    <div class="col-md-12 borderDashed" style="padding: 10px 15px;">
                        <div class="col-md-8" style="padding-left:0px;">
                            <p style="" class="header-text"> {{ H1BDetails.ClientDocuments[0].DisplayText }}</p>
                        </div>
                    </div>
                    <ob-ess-document v-for="(docData, index) in H1BDetails.ClientDocuments" :key="index" :documentList="docData" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- H1B Client Documents -->


                <!-- H1B RFE Documents -->
                <div class="row PL1" v-if="H1BDetails.RFEDocuments && H1BDetails.RFEDocuments.length > 0">
                    <div class="col-md-12 borderDashed" style="padding: 10px 15px;">
                        <div class="col-md-8" style="padding-left:0px;">
                            <p style="" class="header-text"> {{ H1BDetails.RFEDocuments[0].DisplayText }}</p>
                        </div>
                    </div>
                    <ob-ess-document v-for="(docData, index) in H1BDetails.RFEDocuments" :key="index" :documentList="docData" :sectionDocument="sectionDoc"> </ob-ess-document>
                </div>
                <!-- H1B RFE Documents -->

            </template>
        </ob-folder>
    </div>
</template>
<script>
    import ESSMixin from '../ESSMixin.js'
    import utils from '@/components/Core/utils.js'
    import moment from "moment"

    export default {
        mixins: [ESSMixin],
        props: {
            H1BDetails: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                H1BLoader: false,
                sectionDoc: 'H1B',
            }
        },

        created() {
            this.H1BLoader = true;
        },

        mounted() {
            this.H1BLoader = false;
        },

        computed: {
            getH1bStartDate(){
                if(this.H1BDetails.StartDate){
                if(this.H1BDetails.StartDate !='0001/01/01T05:30:00' && this.H1BDetails.StartDate !='0001/01/01T00:00:00' && this.H1BDetails.StartDate !='0001-01-01T05:30:00' && this.H1BDetails.StartDate !='0001-01-01T00:00:00')
                    return  moment.utc(String(this.H1BDetails.StartDate)).format('MM/DD/YYYY')
                    else
                    return 'N/A'
                 }

            },
            getDate1DisplayName(){ 
                   if(this.H1BDetails.h1BStatus == 'H-1B Approved' || this.H1BDetails.h1BStatus == 'H-1B Approved - Port of Entry' || this.H1BDetails.h1BStatus == 'H-1B Approved - Port of Entry Denied' || this.H1BDetails.h1BStatus == 'H-1B Approved - Port of Entry Approved' || this.H1BDetails.h1BStatus == 'H-1B Approved - Consular Interview' || this.H1BDetails.h1BStatus == 'H-1B Approved - 221G (Administrative Processing)' || this.H1BDetails.h1BStatus == 'H-1B Approved - Visa Approved' || this.H1BDetails.h1BStatus == 'H-1B Approved - Visa Denied' || this.H1BDetails.h1BStatus == 'H-1B Approved - Port of Exit'){
                       return 'H-1B Start Date'
                    }else if(this.H1BDetails.h1BStatus == 'H-1B In-Progress'){
                        return 'Received Date'
                    }else if(this.H1BDetails.h1BStatus == 'H-1B RFE Received' || this.H1BDetails.h1BStatus == 'H-1B RFE In-Progress'){
                        return 'RFE Notice Date'
                    }else if(this.H1BDetails.h1BStatus == 'H-1B NOID Received' || this.H1BDetails.h1BStatus == 'H-1B NOID In-Progress'){
                        return 'NOID Notice Date'
                    }else if(this.H1BDetails.h1BStatus == 'H-1B NOIR Received' || this.H1BDetails.h1BStatus == 'H-1B NOIR In-Progress'){
                        return 'NOIR Notice Date'
                    }else if(this.H1BDetails.h1BStatus == 'H-1B Revoked'){
                        return 'Revoke Submission Date'
                    } else if(this.H1BDetails.h1BStatus == 'H-1B CAP Case Rejected'){
                        return 'Case Rejection Notice Date'
                    }
                        
                },
                getDate2DisplayName(){
                   if(this.H1BDetails.h1BStatus == 'H-1B Approved' || this.H1BDetails.h1BStatus == 'H-1B Approved - Port of Entry' || this.H1BDetails.h1BStatus == 'H-1B Approved - Port of Entry Denied' || this.H1BDetails.h1BStatus == 'H-1B Approved - Port of Entry Approved' || this.H1BDetails.h1BStatus == 'H-1B Approved - Consular Interview' || this.H1BDetails.h1BStatus == 'H-1B Approved - 221G (Administrative Processing)' || this.H1BDetails.h1BStatus == 'H-1B Approved - Visa Approved' || this.H1BDetails.h1BStatus == 'H-1B Approved - Visa Denied' || this.H1BDetails.h1BStatus == 'H-1B Approved - Port of Exit'){
                       return 'End Date'
                    } else if(this.H1BDetails.h1BStatus == 'H-1B In-Progress'){
                        return 'Notice Date'
                    }else if(this.H1BDetails.h1BStatus == 'H-1B RFE Received' || this.H1BDetails.h1BStatus == 'H-1B RFE In-Progress'){
                        return 'RFE Response Deadline Date'
                    }else if(this.H1BDetails.h1BStatus == 'H-1B NOID Received' || this.H1BDetails.h1BStatus == 'H-1B NOID In-Progress'){
                        return 'NOID Response Deadline Date'
                    }else if(this.H1BDetails.h1BStatus == 'H-1B NOIR Received' || this.H1BDetails.h1BStatus == 'H-1B NOIR In-Progress'){
                        return 'NOIR Notice Date'
                    }
                },
                 petitionDate(){
                     if(this.H1BDetails.PetitionFiledDate){
                     if(this.H1BDetails.PetitionFiledDate !='0001/01/01T05:30:00' && this.H1BDetails.PetitionFiledDate !='0001/01/01T00:00:00' && this.H1BDetails.PetitionFiledDate !='0001-01-01T05:30:00' && this.H1BDetails.PetitionFiledDate !='0001-01-01T00:00:00' && this.H1BDetails.PetitionFiledDate != '0001-01-01T00:00:00Z')
                     return  moment.utc(String(this.H1BDetails.PetitionFiledDate)).format('MM/DD/YYYY')
                     else return 'N/A'
                    }
                },
                 premiumpetitionDate(){
                    if(this.H1BDetails.PremiumPetitionIniatedDate){
                        if(this.H1BDetails.PremiumPetitionIniatedDate !='0001/01/01T05:30:00' && this.H1BDetails.PremiumPetitionIniatedDate !='0001/01/01T00:00:00' && this.H1BDetails.PremiumPetitionIniatedDate !='0001-01-01T05:30:00' && this.H1BDetails.PremiumPetitionIniatedDate !='0001-01-01T00:00:00')
                            return  moment.utc(String(this.H1BDetails.PremiumPetitionIniatedDate)).format('MM/DD/YYYY')
                        else
                            return 'N/A'
                    }
                },
                getH1bStartDate(){
                    if(this.H1BDetails.StartDate){
                        if(this.H1BDetails.StartDate !='0001/01/01T05:30:00' && this.H1BDetails.StartDate !='0001/01/01T00:00:00' && this.H1BDetails.StartDate !='0001-01-01T05:30:00' && this.H1BDetails.StartDate !='0001-01-01T00:00:00')
                        return  moment.utc(String(this.H1BDetails.StartDate)).format('MM/DD/YYYY')
                        else return 'N/A'
                    }
                },
                getH1bEndDate(){
                    if(this.H1BDetails.EndDate){
                        if(this.H1BDetails.EndDate !='0001/01/01T05:30:00' && this.H1BDetails.EndDate !='0001/01/01T00:00:00' && this.H1BDetails.EndDate !='0001-01-01T05:30:00' && this.H1BDetails.EndDate !='0001-01-01T00:00:00')
                        return  moment.utc(String(this.H1BDetails.EndDate)).format('MM/DD/YYYY')
                        else return 'N/A'
                    }
                },
        },

        methods: {
            previewHTML(){
                // var w = window.open();
                // var printOne = this.H1BDetails.CheckListPreviewInfo;
                //w.document.write

                // w.document.write('<html><head>  </head><style> body{ font-family: "Open Sans", sans-serif } .hide-in-print{display:none} .table-tag{width:-webkit-fill-available;background-color:transparent;border-spacing:0;border-collapse:collapse;display:inline-table;border-color:grey;} .tbody-class{display:table-row-group;vertical-align:middle;border-color:inherit;} .tr-class{display:table-row;vertical-align:inherit;border-color:inherit;}.li:after{content:\'\';background:#656262;position:absolute;top:28.6px;width:46px;height:2px;margin-left:165px;}.li:after:last-child:after{width:0px !important;}.greather-content{padding-bottom:5px;color:#000;font-size:13px;margin-bottom:0px}.change-width{width:22% !important}.textarea{background:#fff;border:1px solid #e5e5e5;border-radius:5px;width:100%;height:75px;resize:none;color:#555555;} .approve-heading{color:#000;font-weight:500;font-size:25px;padding-top:13px;} .approve-text{font-weight:normal;font-size:14px;padding-bottom:30px;} .approve-text p{font-size:13px;} .td1{padding-bottom:5px;font-size:13px;} .td2{padding-bottom:5px;color:#143361;font-size:13.5px;font-weight:600;} .td3{padding-bottom:25px;font-size:12px;} .td4{padding-bottom:10px;color:#143361;font-size:12px;font-weight:900;} .td6{padding-bottom:20px;font-size:12px;} .td5{padding-bottom:15px;font-size:12px;}.value-text{margin-top:0;padding-bottom:5px;color:#143361;font-size:13.5px;font-weight:600 }.hide-visibility{visibility:hidden !important }.table-tag{width:-webkit-fill-available;background-color:transparent;border-spacing:0;border-collapse:collapse;display:inline-table;border-color:grey;} .tbody-class{display:table-row-group;vertical-align:middle;border-color:inherit;} .tr-class{display:table-row;vertical-align:inherit;border-color:inherit;}#project_clientDetails{overflow:auto;} .ul{margin:4px;display:inline-flex;} .li{width:145px;height:64px;position:relative;list-style-type:none;background:white;padding:12px 10px 10px 12px;border:2px solid white;-webkit-box-shadow:0 0 9.5px #dcd7d7;box-shadow:0 0 9.5px #dcd7d7;border-radius:0%;float:left;margin-left:62px;margin-bottom:25px;} .website_txt{font-size:11px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;padding-bottom:1.5px;font-weight:600;} .website_org{color:#143361;font-size:13px;font-weight:600;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;} &:after{background:#656262;position:absolute;top:28.6px;width:46px;height:2px;margin-left:139px;} .circle{width:1em;height:1em;box-sizing:initial;background:#fff;border:0.3em solid #656262;color:#666;border-radius:50%;line-height:2rem;box-sizing:content-box;} &:last-child:after{width:0px !important;} &:last-child{.left{display:none;} } &:first-child{margin-left:0;} i{border:solid #656262;border-width:0 1.5px 1.5px 0;display:inline-block;padding:3px;} .right{position:absolute;left:-20px;top:26px;border-color:none;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);} .left{position:absolute;right:-14px;margin-right:-4px;top:26px;z-index:1;border-color:none;transform:rotate(135deg);-webkit-transform:rotate(135deg);} table{border-collapse:collapse;border-spacing:0;}td,th{padding:0;} .document-list__heading{border:1px solid #1DC942;background:#f4fef7;}.document-list__status{background:#a4f3b5;color:#1DC942;}.pL0{padding-left:0 !important;}.pR0{padding-right:0 !important;}.modal{display:none}.document-list__header{position:relative;z-index:1;} .document-list__heading{padding:5px 10px;border:1px solid $default-border-color;display:inline-block;border-radius:30px;font-weight:bold;background:$default-background-color;float:left;} .document-list__headings{padding:5px 10px;border:1px solid #c2c2c2;display:inline-block;border-radius:30px;font-weight:bold;background:$default-background-color;float:left;} .document-list__status{background:$default-border-color;color:$default-background-color;padding:0px 5px;border-radius:100%;} .multilpe-doc{background:#c2c2c2;color:#fdfdfd;padding:0px 5px;border-radius:100%;} .document-list__controls{float:right;}  .document-list__body{position:relative;} .file_name_span{//overflow:hidden;text-overflow:ellipsis;white-space:nowrap;//max-width:600px;display:inline-block;} .progress{overflow:hidden;height:5px;margin-bottom:0;background-color:#f5f5f5;border-radius:10px;-webkit-box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);} .upload_div, .upload_file_div{padding:35px;background:#FAFEFF;border:2px dashed #ccc;border-radius:8px;display:table;width:100%;cursor:pointer;text-align:center;&.dragover{background:#fff;} } .upload_file_div{padding:15px;cursor:default;} .upload-inner{display:table-cell;vertical-align:middle;padding:15px;width:15%;} .width-70{width:70%;} .testt{padding:0px } .margin-top-25{margin-top:25px;} .upload_img{padding:15px 0 20px 0;} .upload_text{padding:0 0 20px 0;} .icon{width:50px;} .icon1{width:35px;} .info{margin:0;font-size:13px;line-height:18px;color:#999;display:inline-block;} .file_name_span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;//width:600px;display:inline;} .error-holder{margin:10px 0;} .error-msg{color:$ob-error-red;} .slide-fade-enter-active{transition:all .3s ease;} .slide-fade-leave-active{transition:all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);} .slide-fade-enter, .slide-fade-leave-to{transform:translateX(10px);opacity:0;} .signature-holder{.document-signer{font-size:16px;font-weight:600;color:#337AB5;} .signauture-success{font-size:9px;color:#FFFFFF;background:#3CB55B !important;} .signauture-pending{font-size:9px;color:#FFFFFF;background:#008BE7 !important;} .document-signature-details{font-size:14px;color:#2A2A2A;} }.animation{animation-duration:1s;animation-fill-mode:both;display:inline-block;} .bounceOutLeft{animation-name:bounceOutLeft } @keyframes bounceOutLeft{18%{transform:translate3d(27px, 0, 0) } 33%{transform:translate3d(-12px, 0, 0) } 48%{transform:translate3d(8px, 0, 0) } 100%{transform:translate3d(-300%, 0, 0) } } @keyframes bounceInUp{0%{opacity:0;-webkit-transform:translateY(2000px);-ms-transform:translateY(2000px);transform:translateY(2000px);} 60%{opacity:1;-webkit-transform:translateY(-30px);-ms-transform:translateY(-30px);transform:translateY(-30px);} 80%{-webkit-transform:translateY(10px);-ms-transform:translateY(10px);transform:translateY(10px);} 100%{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);} } .bounceOuttop{animation-name:bounceInUp } .ActionTruncateStyle{z-index:unset !important;} .fontWeightStyle{font-weight:bold;} .PaddingBottomStyle{padding-bottom:25px;} .document-table-value{font-size:13px;font-weight:600;color:#143361;}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;}@media (min-width:768px){.container{width:750px;}}@media (min-width:992px){.container{width:970px;}}@media (min-width:1200px){.container{width:1170px;}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;}.row{margin-left:-15px;margin-right:-15px;}.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12{position:relative;min-height:1px;padding-left:15px;}.col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12{float:left;}.col-xs-12{width:100%;}.col-xs-11{width:91.66666667%;}.col-xs-10{width:83.33333333%;}.col-xs-9{width:75%;}.col-xs-8{width:66.66666667%;}.col-xs-7{width:58.33333333%;}.col-xs-6{width:50%;}.col-xs-5{width:41.66666667%;}.col-xs-4{width:33.33333333%;}.col-xs-3{width:25%;}.col-xs-2{width:16.66666667%;}.col-xs-1{width:8.33333333%;}.col-xs-pull-12{right:100%;}.col-xs-pull-11{right:91.66666667%;}.col-xs-pull-10{right:83.33333333%;}.col-xs-pull-9{right:75%;}.col-xs-pull-8{right:66.66666667%;}.col-xs-pull-7{right:58.33333333%;}.col-xs-pull-6{right:50%;}.col-xs-pull-5{right:41.66666667%;}.col-xs-pull-4{right:33.33333333%;}.col-xs-pull-3{right:25%;}.col-xs-pull-2{right:16.66666667%;}.col-xs-pull-1{right:8.33333333%;}.col-xs-pull-0{right:auto;}.col-xs-push-12{left:100%;}.col-xs-push-11{left:91.66666667%;}.col-xs-push-10{left:83.33333333%;}.col-xs-push-9{left:75%;}.col-xs-push-8{left:66.66666667%;}.col-xs-push-7{left:58.33333333%;}.col-xs-push-6{left:50%;}.col-xs-push-5{left:41.66666667%;}.col-xs-push-4{left:33.33333333%;}.col-xs-push-3{left:25%;}.col-xs-push-2{left:16.66666667%;}.col-xs-push-1{left:8.33333333%;}.col-xs-push-0{left:auto;}.col-xs-offset-12{margin-left:100%;}.col-xs-offset-11{margin-left:91.66666667%;}.col-xs-offset-10{margin-left:83.33333333%;}.col-xs-offset-9{margin-left:75%;}.col-xs-offset-8{margin-left:66.66666667%;}.col-xs-offset-7{margin-left:58.33333333%;}.col-xs-offset-6{margin-left:50%;}.col-xs-offset-5{margin-left:41.66666667%;}.col-xs-offset-4{margin-left:33.33333333%;}.col-xs-offset-3{margin-left:25%;}.col-xs-offset-2{margin-left:16.66666667%;}.col-xs-offset-1{margin-left:8.33333333%;}.col-xs-offset-0{margin-left:0%;}@media (min-width:768px){.col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12{float:left;} .col-sm-12{width:100%;} .col-sm-11{width:91.66666667%;} .col-sm-10{width:83.33333333%;} .col-sm-9{width:75%;} .col-sm-8{width:66.66666667%;} .col-sm-7{width:58.33333333%;} .col-sm-6{width:50%;} .col-sm-5{width:41.66666667%;} .col-sm-4{width:33.33333333%;} .col-sm-3{width:25%;} .col-sm-2{width:16.66666667%;} .col-sm-1{width:8.33333333%;} .col-sm-pull-12{right:100%;} .col-sm-pull-11{right:91.66666667%;} .col-sm-pull-10{right:83.33333333%;} .col-sm-pull-9{right:75%;} .col-sm-pull-8{right:66.66666667%;} .col-sm-pull-7{right:58.33333333%;} .col-sm-pull-6{right:50%;} .col-sm-pull-5{right:41.66666667%;} .col-sm-pull-4{right:33.33333333%;} .col-sm-pull-3{right:25%;} .col-sm-pull-2{right:16.66666667%;} .col-sm-pull-1{right:8.33333333%;} .col-sm-pull-0{right:auto;} .col-sm-push-12{left:100%;} .col-sm-push-11{left:91.66666667%;} .col-sm-push-10{left:83.33333333%;} .col-sm-push-9{left:75%;} .col-sm-push-8{left:66.66666667%;} .col-sm-push-7{left:58.33333333%;} .col-sm-push-6{left:50%;} .col-sm-push-5{left:41.66666667%;} .col-sm-push-4{left:33.33333333%;} .col-sm-push-3{left:25%;} .col-sm-push-2{left:16.66666667%;} .col-sm-push-1{left:8.33333333%;} .col-sm-push-0{left:auto;} .col-sm-offset-12{margin-left:100%;} .col-sm-offset-11{margin-left:91.66666667%;} .col-sm-offset-10{margin-left:83.33333333%;} .col-sm-offset-9{margin-left:75%;} .col-sm-offset-8{margin-left:66.66666667%;} .col-sm-offset-7{margin-left:58.33333333%;} .col-sm-offset-6{margin-left:50%;} .col-sm-offset-5{margin-left:41.66666667%;} .col-sm-offset-4{margin-left:33.33333333%;} .col-sm-offset-3{margin-left:25%;} .col-sm-offset-2{margin-left:16.66666667%;} .col-sm-offset-1{margin-left:8.33333333%;} .col-sm-offset-0{margin-left:0%;}}@media (min-width:992px){.col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12{float:left;} .col-md-12{width:100%;} .col-md-11{width:91.66666667%;} .col-md-10{width:83.33333333%;} .col-md-9{width:75%;} .col-md-8{width:66.66666667%;} .col-md-7{width:58.33333333%;} .col-md-6{width:50%;} .col-md-5{width:41.66666667%;} .col-md-4{width:33.33333333%;} .col-md-3{width:25%;} .col-md-2{width:16.66666667%;} .col-md-1{width:8.33333333%;} .col-md-pull-12{right:100%;} .col-md-pull-11{right:91.66666667%;} .col-md-pull-10{right:83.33333333%;} .col-md-pull-9{right:75%;} .col-md-pull-8{right:66.66666667%;} .col-md-pull-7{right:58.33333333%;} .col-md-pull-6{right:50%;} .col-md-pull-5{right:41.66666667%;} .col-md-pull-4{right:33.33333333%;} .col-md-pull-3{right:25%;} .col-md-pull-2{right:16.66666667%;} .col-md-pull-1{right:8.33333333%;} .col-md-pull-0{right:auto;} .col-md-push-12{left:100%;} .col-md-push-11{left:91.66666667%;} .col-md-push-10{left:83.33333333%;} .col-md-push-9{left:75%;} .col-md-push-8{left:66.66666667%;} .col-md-push-7{left:58.33333333%;} .col-md-push-6{left:50%;} .col-md-push-5{left:41.66666667%;} .col-md-push-4{left:33.33333333%;} .col-md-push-3{left:25%;} .col-md-push-2{left:16.66666667%;} .col-md-push-1{left:8.33333333%;} .col-md-push-0{left:auto;} .col-md-offset-12{margin-left:100%;} .col-md-offset-11{margin-left:91.66666667%;} .col-md-offset-10{margin-left:83.33333333%;} .col-md-offset-9{margin-left:75%;} .col-md-offset-8{margin-left:66.66666667%;} .col-md-offset-7{margin-left:58.33333333%;} .col-md-offset-6{margin-left:50%;} .col-md-offset-5{margin-left:41.66666667%;} .col-md-offset-4{margin-left:33.33333333%;} .col-md-offset-3{margin-left:25%;} .col-md-offset-2{margin-left:16.66666667%;} .col-md-offset-1{margin-left:8.33333333%;} .col-md-offset-0{margin-left:0%;}}@media (min-width:1200px){.col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12{float:left;} .col-lg-12{width:100%;} .col-lg-11{width:91.66666667%;} .col-lg-10{width:83.33333333%;} .col-lg-9{width:75%;} .col-lg-8{width:66.66666667%;} .col-lg-7{width:58.33333333%;} .col-lg-6{width:50%;} .col-lg-5{width:41.66666667%;} .col-lg-4{width:33.33333333%;} .col-lg-3{width:25%;} .col-lg-2{width:16.66666667%;} .col-lg-1{width:8.33333333%;} .col-lg-pull-12{right:100%;} .col-lg-pull-11{right:91.66666667%;} .col-lg-pull-10{right:83.33333333%;} .col-lg-pull-9{right:75%;} .col-lg-pull-8{right:66.66666667%;} .col-lg-pull-7{right:58.33333333%;} .col-lg-pull-6{right:50%;} .col-lg-pull-5{right:41.66666667%;} .col-lg-pull-4{right:33.33333333%;} .col-lg-pull-3{right:25%;} .col-lg-pull-2{right:16.66666667%;} .col-lg-pull-1{right:8.33333333%;} .col-lg-pull-0{right:auto;} .col-lg-push-12{left:100%;} .col-lg-push-11{left:91.66666667%;} .col-lg-push-10{left:83.33333333%;} .col-lg-push-9{left:75%;} .col-lg-push-8{left:66.66666667%;} .col-lg-push-7{left:58.33333333%;} .col-lg-push-6{left:50%;} .col-lg-push-5{left:41.66666667%;} .col-lg-push-4{left:33.33333333%;} .col-lg-push-3{left:25%;} .col-lg-push-2{left:16.66666667%;} .col-lg-push-1{left:8.33333333%;} .col-lg-push-0{left:auto;} .col-lg-offset-12{margin-left:100%;} .col-lg-offset-11{margin-left:91.66666667%;} .col-lg-offset-10{margin-left:83.33333333%;} .col-lg-offset-9{margin-left:75%;} .col-lg-offset-8{margin-left:66.66666667%;} .col-lg-offset-7{margin-left:58.33333333%;} .col-lg-offset-6{margin-left:50%;} .col-lg-offset-5{margin-left:41.66666667%;} .col-lg-offset-4{margin-left:33.33333333%;} .col-lg-offset-3{margin-left:25%;} .col-lg-offset-2{margin-left:16.66666667%;} .col-lg-offset-1{margin-left:8.33333333%;} .col-lg-offset-0{margin-left:0%;}}.footer-line{margin-top:20px;border-bottom:1px dashed grey;margin-bottom:20px;} .doc-header{color:#000;font-weight:600;font-size:14px;font-weight:600px;} .request-doc-header{color:#143361;font-weight:700;font-size:16px;padding-left:25px;} .icon-header{padding-right:50px;} .info-text-blue{color:#4A90E2;font-size:15px;} .info-text-green{color:#1DC942;font-size:15px;} .info-text{font-size:15px;} .listDocs-text{color:#4A90E2;font-weight:600;font-size:13px;} .doc-overflow{overflow:auto;height:100%;} .status-options{margin:26px 0 0 0;} .section-personal{border-bottom:2px dashed #c2c2c2;padding:10px 0;} .checklist-docs{overflow:auto;height:100%;} .btnUpload{width:79px;height:28px;background-color:#1d437b } .document-list__headingStyle{padding:5px 10px;border:1px solid #c2c2c2;display:inline-block;border-radius:30px;font-weight:bold;//background:#c2c2c2;} .document-list__statusStyle{background:#c2c2c2;color:#fdfdfd;padding:0px 5px;border-radius:100%;margin-left:30px;} .star{color:red;} .heading-text{color:#000;font-weight:700;font-size:13px;padding:20px 0px 0px 15px;} .upload-text{padding:0px 0px 10px 25px } .names-text{color:#000;padding-top:20px;font-weight:700;font-size:12px;} .label-text{padding-bottom:5px;color:#000;font-size:13px;} .checklist-docs{overflow:auto;height:100%;} .contact-info-text{color:#000;font-size:13px;font-weight:700;padding-top:15px;} .radio-buttons{margin-left:-20px;} .current-info-text{color:#000;padding:15px 0px 0px 15px;font-weight:700;font-size:13px;} .footer-buttons{text-align:center;padding-top:30px;} .actions-text{padding-bottom:20px;text-align:right;margin-left:186px;} .required-docs-text{color:#000;padding:15px 0px 0px 0px;font-weight:700;font-size:13px;} .add-name{color:#4A90E2;font-style:italic;text-decoration:underline;font-weight:700;padding-left:5px;cursor:pointer;} .btn-upload{padding-bottom:20px;} .section-heading-dependent{color:#393939;font-weight:600;font-size:17px } .radio-label{color:#393939;font-weight:600;} .remove-worklocation{float:right;color:#D60000;font-size:11px;font-weight:650;margin-top:5px;padding-right:4px } .remove-location{float:right;color:#D60000;font-size:11px;font-weight:650;margin-top:5px;padding-right:26px } .fontStyle{font-weight:bold;padding:15px;font-size:17px;border-bottom:1px dashed #ccc;} .infoStyle{color:#4191ef;padding-bottom:25px;font-weight:600;} .fontHeadStyle{padding-bottom:15px;font-weight:600;font-size:13px;color:#143361;} .fontSubHeadPadStyle{padding-bottom:10px;} .fontSubHeadStyle{font-size:14px;padding-bottom:10px;font-weight:600;color:#143361;} .fontSubHeadBoldStyle{font-weight:600;color:#143361;overflow-wrap:break-word;} .fontSubHeBoldStyle{font-weight:bold;} .fontSubHeadBoldPadStyle{font-weight:600;padding-left:8px;color:#143361;overflow-wrap:break-word;} .fontStySubHeadBoldPadStyle{font-weight:600;padding-left:22px;color:#143361;overflow-wrap:break-word;} .IconTitleColor{color:rgb(40, 167, 69);font-weight:bold;} .IconTitleblueColor{padding-left:0px;font-weight:bold;color:#4A90E2;} .padIconStyle{padding-bottom:20px;} .padStyle{padding-top:10px;padding-bottom:30px;} .padArrowLeftStyle{padding-left:60px;} .document-list__headingApprovedStyle{padding:5px 10px;border:1px solid #3CB55B;display:inline-block;border-radius:30px;font-weight:bold;background:#F9F9F9;float:left;} .document-list__statusApprovedStyle{background:#ACF3BE;color:#3CB55B;padding:0px 5px;border-radius:100%;} .fontCheckStyle{font-size:14px;font-weight:600;color:#143361;} .fontborderStyle{padding-bottom:25px;padding-top:25px;padding-left:0px;border-top:1px dashed #ccc;} .fontborderSolidStyle{padding-top:35px;padding-left:0px;padding-bottom:40px;border-top:1px solid #ccc;text-align:center;} .fontSizeInfoIconStyle{font-size:17px;} .margPillStyle{margin-left:-10px;} .at{color:#143361;font-weight:600;font-size:21px;padding-top:13px;} .pas{font-weight:normal;font-size:14px;padding-bottom:30px;} .pas p{color:#727d8c;font-size:13px;font-weight:600;} .ContenttoBottomStyle{//padding-bottom:10% !important;} .BorderStyle{border-bottom:1px solid grey;padding-bottom:20px;} .close{border:1px solid black;border-radius:12px;}.input-field-field{width:60%;height:20px;//padding:1.5%;margin-right:5%;display:inline-block;border-radius:10px;//box-sizing:border-box;}.input-field{width:100%;margin-right:5%;background:#666666;border-radius:10px;box-sizing:border-box;}.fixed-org{display:flex;justify-content:left;padding-top:2%;}.align-org{display:flex;justify-content:left;padding-top:4%;}.vl{border-left:1px solid #DFDFDF;position:inherit;margin-left:5%;margin-top:-12px;width:134%;}.org-vl{border-left:1px solid #DFDFDF;position:inherit;margin-left:5%;margin-top:-12px;width:134%;padding-left:57px;}.org-main-align{border-left:1px solid #DFDFDF;position:inherit;}.add-another-text-align{position:inherit;margin-left:5%;margin-top:-10px;width:134%;margin-top:-22px;margin-left:42px;}.add-position{margin-top:5%;margin-left:-14px;cursor:pointer;}.line{margin-top:40px;width:10%;}.heading{padding-top:5% !important;padding-bottom:5% !important;}.normal-input{background:white !important;}*:focus{outline:none;}.flow-digram{height:50%;width:30%}.add-another-client{margin-top:10px;color:#4A90E2;font-style:italic;font-weight:700;font-size:11px;cursor:pointer;}.endclient-details{display:flex;width:140%;justify-content:left;padding-left:5%;} .end-client-name{//text-align:left;// padding-left:80px !important;font-size:12px;color:#000;padding-bottom:5px;} .end-client-website{// float:right;//margin-right:-38px !important;font-size:12px;color:#000;padding-bottom:5px;} .client-details{font-size:12px;color:#000;margin-left:15%;margin-bottom:-18px;display:inline-block;} .client-website{font-size:12px;color:#000;margin-left:45%;display:inline-block;} .vendor-details{font-size:12px;color:#000;margin-left:15%;margin-bottom:-18px;display:inline-block;} .vendor-website{font-size:12px;color:#000;margin-left:40%;display:inline-block;} .organization{font-size:12px;color:#000;padding-left:0px;padding-bottom:5px;//margin-left:39px;} .input-client-field{//width:100%;// margin-right:5%;border-radius:10px;box-sizing:border-box;} .padToppSty{padding-top:10px;} .remove-name{color:#D60000;font-style:italic;text-decoration:underline;font-weight:800;font-size:13px;padding-left:5px;cursor:pointer;} .commentTopStyle{background:#ffd9cd;border-radius:4px;white-space:normal;padding-left:9px;padding-top:5px;padding-bottom:5px;overflow-wrap:break-word;} .commentStyle{background:#efefef;border-radius:4px;white-space:normal;padding-left:9px;padding-top:5px;padding-bottom:5px;overflow-wrap:break-word;} .document-list__ApproveStatusESSStyle{background:#c7ffd3;color:#079f6c;padding:0px 5px;border-radius:100%;font-size:10px;} .document-list__RejectStatusESSStyle{background:#D60000;color:#fff;padding:0px 5px;border-radius:100%;font-size:10px;} .padBottomStyle{padding-top:10px;} .conditionalBorder{border-bottom:2px dashed #789acc;margin-bottom:15px !important;padding-top:15px !important;} </style> <body>' + printOne + '</body></html>');

                // setTimeout(() => {
                            //     w.window.print();
                            //     w.document.close();
                        
                            // }, 100)
                    let link = this.H1BDetails.CheckListPreviewPDFURL;
                //window.open(link, "_blank");
                 utils.previewSingleDoc(link)
            },
            downloadHTML() {
                let link = this.H1BDetails.CheckListPreviewPDFURL;
                utils.downloadSingleDoc(link)
                //window.open(link, "_blank");
            },
            openempchecklistForm() {
                var from = this.$route.name;
                var H1bId;
                this.$router.push({
                    name: 'H1BPetitionEmpChecklistDocs',
                    query: {
                        from: from,
                        H1bId: this.H1BDetails.h1bId,
                        Status: this.H1BDetails.essDocumentStatus
                        //RequestId: this.H1BDetails.RequestId
                    }
                })
            },

            getSignedDate() {
                let doc = this.H1BDetails.documentI539
                var signedDate = ''
                if(doc != null && doc.MetadataValues != null && doc.MetadataValues.length > 0){
                    doc.MetadataValues[0].DocumentData.forEach((s) => {
                        if (s.Key == "SignedDate") {
                            signedDate = s.Value
                        }
                    })
                    return signedDate
                }
                },
            getSignedDateI539A(I539A) {
                var signedDate = ''
                if(I539A != null && I539A.DocumentData != null && I539A.DocumentData.length > 0){
                    I539A.DocumentData.forEach((s) => {
                        if (s.Key == "SignedDate") {
                            signedDate = s.Value
                        }
                    })
                    return signedDate
                }
                },
            getFormI539AName(I539A){
                var Name = ''
                if(I539A != null && I539A.DocumentData != null && I539A.DocumentData.length > 0){
                    I539A.DocumentData.forEach((s) => {
                        if (s.Key == "Name") {
                            Name = s.Value
                        }
                    })
                    return Name  
                }
            },
            viewDocumentI539A(I539A){
                var docUrl = ''
                if(I539A != null && I539A.DocumentData != null && I539A.DocumentData.length > 0){
                    I539A.DocumentData.forEach((s) => {
                        if (s.Key == "DocumentUrl") {
                            docUrl = s.Value
                        }
                    })
                    utils.previewSingleDoc(docUrl)
                }
            },
            downloadDocumentI539A(I539A){
                var docUrl = ''
                if(I539A != null && I539A.DocumentData != null && I539A.DocumentData.length > 0){
                    I539A.DocumentData.forEach((s) => {
                        if (s.Key == "DocumentUrl") {
                            docUrl = s.Value
                        }
                    })
                    utils.downloadSingleDoc(docUrl)
                }
            },

            viewDocument(type) {
                let docUrl = this.getTheDocumentUrl(type)

                if(docUrl)
                    utils.previewSingleDoc(docUrl)
            },

            downloadDocument(type) {
                let docUrl = this.getTheDocumentUrl(type)
                
                if(docUrl)
                    utils.downloadSingleDoc(docUrl)
            },

            getTheDocumentUrl(type){
                let doc = '' 
                let docUrl = ''
                if(this.H1BDetails){
                    if(type == 'LCA')
                        doc = this.H1BDetails.documentLCA
                    else if(type=='FormI539')
                        doc = this.H1BDetails.documentI539
                    else if(type == 'CompleteH1B')
                        doc = this.H1BDetails.documentComplete
                    else if(type == 'FormI129')
                        doc = this.H1BDetails.documentI129
                    else if(type == 'SignedFormI129')
                        doc = this.H1BDetails.documentI129Signed

                    if(doc && doc.MetadataValues && doc.MetadataValues.length > 0 && doc.MetadataValues[0].DocumentData 
                           && doc.MetadataValues[0].DocumentData.length > 0){
                        doc.MetadataValues[0].DocumentData.forEach((s) => {
                            if (s.Key == "DocumentUrl")
                                docUrl = s.Value
                        })
                    }
                }
                return docUrl
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "~styles/framework/vue-utils";
    .folder-header-heading,
    .folder-header-sub-heading
    {
        font-weight: 600;
        margin-bottom: 5px;
        color: #333;
    }
    
    .h1b-status {
        padding: 5px;
        span {
            display: block;
        }
        .h1b-status--message {
            font-weight: 600;
            color: #417505;
        }
        //   .h1b-status{
        //        font-weight:600;
        //        color:#C51C48;
        //   }
    }
    
    .section-intiate {
        border-bottom: 1px solid #707070;
        padding-bottom: 5px;
    }
    
    .soc-datas {
        font-size: 13px;
        color: #143361;
        font-weight: 600;
    }
    
    .header-text {
        font-size: 13px;
        font-weight: 800;
        color: #143361;
        margin-top: 7px;
    }
    
    .padding-col-12 {
        padding: 10px 15px;
    }
    
    label {
        font-weight: 400;
    }
    
    .docs-text {
        color: #000;
        font-size: 13px;
        font-weight: 500;
        text-align: center;
    }
    
    .start-btn {
        text-align: center;
        padding-top: 10px;
        margin-right: 60px;
    }
    
    .inform-text {
        color: #4A90E2;
        font-size: 12px;
        font-weight: 600;
        display: inline-block;
    }
    
    .document-list__headingStyle {
        // padding: 5px 10px;
        // border: 1px solid #FADBAF;
        // display: inline-block;
        // border-radius: 30px;
        // font-weight: bold;
        // background: #FFF8ED;
        padding: 5px 10px;
        border: 1px solid #F5A727;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: #FFF8ED;
        float: left;
    }
    .ApprovedDocument-list__headingStyle {
        padding: 5px 10px;
        border: 1px solid #1DC942;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: #f4fef7;
        float: left;
    }
    .canceldocument-list__headingStyle{
        padding: 5px 10px;
        border: 1px solid #f70606;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: #FFF8ED;
        float: left;
    }
    
    .document-list__statusStyle {
        // background: #ffa500;
        // color: #FADBAF;
        // padding: 0px 5px;
        // border-radius: 100%;
        // margin-left: 30px;
        background: #FFDEA6;
        color: #F5A727;
        padding: 0px 5px;
        border-radius: 100%;
    }
    .ApprovedDocument-list__statusStyle {
        background: #a4f3b5;
        color: #1DC942;
        padding: 0px 5px;
        border-radius: 100%;
    }
    .canceldocument-list__statusStyle{
        background: #FFDEA6;
        color: #e30909;
        padding: 0px 5px;
        border-radius: 100%;
    }
    .H1BPetitonDocStatus {
        background-color: #F5A623;
        padding: 3px 12px 3px 12px !important;
        color: rgb(255, 255, 255);
        font-size: 10px;
        border-radius: 10px;
    }
    
    .margDispStyle {
        margin-left: 4px;
        margin-top: 4px;
        display: inline-table;
    }
    
    // .H1BPetitonDocStatusPending {
    // background-color: #ffa500;
    // padding: 3px 12px 3px 12px!important;
    // color: rgb(255, 255, 255);
    // font-size: 10px;
    // border-radius: 10px;
    // }
    .H1BPetitonDocStatusRejected {
        background-color: #D60000;
        padding: 3px 12px 3px 12px!important;
        color: rgb(255, 255, 255);
        font-size: 10px;
        border-radius: 10px;
    }
    .H1BPetitonDocStatusApproved {
        background-color: #1DC942;
        padding: 3px 12px 3px 12px!important;
        color: rgb(255, 255, 255);
        font-size: 10px;
        border-radius: 10px;
    }
    .cancelH1BPetitonDocStatus{
        background-color: #f90909;
        padding: 3px 12px 3px 12px !important;
        color: rgb(255, 255, 255);
        font-size: 10px;
        border-radius: 10px;
    }
    
    .document-status {
        padding-top: 20px;
    }
    
    .date-fields {
        padding-left: 10px;
    }
    
    .submitted-date {
        display: inline-block;
    }
    
    .reviewed-by {
        display: inline-block;
        padding-left: 120px;
    }
    
    .reviewed-date {
        display: inline-block;
        padding-left: 120px;
    }
    
    .date {
        color: #143361;
        font-size: 12px;
        font-weight: 600;
    }
    
    .reasons-for-rejection {
        display: inline-block;
        padding: 2px 0px 0px 2px;
    }
    
    .rejection-text {
        color: #143361;
        padding-left: 5px;
    }
    
    .rejection-emptytext {
        color: #143361;
    }
    
    .reason-headding {
        padding: 0px 0px 10px 0px;
    }
    
    .reasons {
        background-color: #DFDFDF;
        border-radius: 5px;
        padding: 10px;
        font-weight: 600;
    }
    
    .fontWeighStyle {
        color: #143361;
        font-size: 12px;
        font-weight: 600;
    }

    .infoSec{
        margin-left: 5px;
        margin-bottom: 10px;
    }
    
    .infofields {
        padding-bottom: 15px;
        padding-top: 10px;
    }

    .courierinfofields{
        padding-bottom: 15px;
        padding-top: 10px;
        margin-left: 15px;
    }
    
    .padTopStyle {
        padding-top: 15px;
    }
    
    .fontWeightSty {
        font-weight: bold;
    }
    
    .padTopLowStyle {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    
    .reqH1BEmpTextStyle {
        color: #4A90E2;
        padding-bottom: 3px;
        font-weight: bold;
    }
    
    .fontSizeIconStyle {
        font-size: 17px;
    }
    
    .document-list__NoDocument {
        padding: 5px 10px;
        border: 1px solid #c2c2c2;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: #fdfdfd;
        float: left;
    }
    
    .document-list__NostatusStyle {
        background: #c2c2c2;
        color: #fdfdfd;
        padding: 0px 5px;
        border-radius: 100%;
    }
    
    .document-list__headingApprovedStyle {
        padding: 5px 10px;
        border: 1px solid #3CB55B;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: #F9F9F9;
        float: left;
    }
    
    .document-list__statusApprovedStyle {
        background: #ACF3BE;
        color: #3CB55B;
        padding: 0px 5px;
        border-radius: 100%;
    }
    .padBotHighStyle{
    padding-bottom:10px; 
  }
  .padTopBotStyle{
    padding-top:15px;
    padding-bottom:15px;
  }
  .Excess_Content {
        width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        white-space: nowrap;
    }
    .excess-header {
            width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            white-space: nowrap;
        }
        .padBotStyle{
    padding-bottom:5px;
  }
  .commentStyle {
        background: #efefef;
        border-radius: 4px;
        white-space: normal;
        padding-left: 9px;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .Headline_StatusIncompleteMessage{
        font-size: 10.5px;
        font-weight: bold;
        color: #fba16b;
    }
    .Headline_StatusRejectedMessage{
        font-size: 10.5px;
        font-weight: bold;
        color: #D60000;
    }
    .Headline_StatusApprovedMessage{
        font-size: 13px;
        font-weight: 659;
        color: #3CB55B;
    }
    .borderDashed {
        border-top: 1px dashed #c2c2c2;
    }
    .borderSolid {
        border-top: 1px solid #c2c2c2;
    }
    .oneDoc{
        padding: 8px 30px 23px 5px;
    }
    .PL1{
        padding-left: 5px;
    }
    .PL2{
        padding-left:10px;
    }
    .PL3{
        padding-left:20px;
        padding-right:17px;
    }
    .PR2{
        padding-right:15px;
    }
    .PD1 {
        padding-bottom: 23px;
        padding-top: 8px;
    }
    .PD3{
        padding-left: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/EmpH1B/EmpH1BSingle.vue